import { memo, useCallback } from 'react'

import { BackButton, SlideUp } from 'common-components'
import PlaybackSpeedOptionList from '../Components/Options'
import * as Styled from './styled'

interface IProps {
  selectedValue: number | string
  handleValueClick: (value: number) => void
  onBack: () => void
  isOpen: boolean
  onClose: () => void
}

const MobilePlaybackSpeedMenu: React.FC<IProps> = ({
  selectedValue,
  handleValueClick,
  onBack,
  isOpen,
  onClose
}) => {
  const handleClick = useCallback(
    (value: number) => {
      requestAnimationFrame(() => {
        handleValueClick(value)
      })
    },
    [handleValueClick]
  )
  return (
    <SlideUp isOpen={isOpen} onClose={onClose}>
      <Styled.MobilePlaybackSpeedSheet>
        <BackButton onClick={onBack} />
        <Styled.MobilePlaybackSpeedOptionsRow>
          <PlaybackSpeedOptionList
            selectedValue={selectedValue}
            handleValueClick={handleClick}
          />
        </Styled.MobilePlaybackSpeedOptionsRow>
      </Styled.MobilePlaybackSpeedSheet>
    </SlideUp>
  )
}

export default memo(MobilePlaybackSpeedMenu)
